var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpGo = function SvgUpGo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#upGo_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 5,
    y: 2,
    fill: "#121111",
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    fillRule: "evenodd",
    d: "M21.57 17.048a.76.76 0 0 1-.538-.223l-4.033-4.032-4.032 4.032a.761.761 0 1 1-1.078-1.077l4.572-4.571a.76.76 0 0 1 1.077 0l4.571 4.57a.761.761 0 0 1-.538 1.301",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "upGo_svg__a",
    width: 34,
    height: 34,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.606673 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_2533"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3_2533",
    result: "shape"
  })))));
};
export default SvgUpGo;